import { render, staticRenderFns } from "./bindMail.vue?vue&type=template&id=7f98b476&"
import script from "./bindMail.vue?vue&type=script&lang=js&"
export * from "./bindMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports